/* global d3 $ */
import dataService from '../../service/dataService.js'
import pipeService from '../../service/pipeService.js';
import DrawMainView from './drawMainView.js'

function isEmpty(obj) {
    return Object.keys(obj).length === 0;
}

export default {
    name: 'MainView',
    components: {
    },
    props: {
        mainViewData: {},
        
    },
    computed: {
    },
    data() {
        return {
            containerId: "mainViewContainer",
            containerIdDict: {
                "mainView": "mainViewContainer",
                "qs": "qsContainer",
                "relation": "relationContainer",
                "tc": "tcContainer"
            },
            selected_items: [], 
            selected_concepts: [],
            selected_relation: [],
            color_selector_radio: '1',
            projection_selector_radio: '1',
            current_inspected: 0,
            hover_data: -1,
            color_items:  [],
            projection_selector_options: [
                {label: "Original", value: "1"},
                {label: "Relation", value: "2"},
                {label: "Correctness", value: "3"},
                {label: "Original x Transformed", value: "4"},
                {label: "Relation x Transformed", value: "5"},
                {label: "Correctness x Transformed", value: "6"},
            ],
            color_selector_options:[
                {label: "Relation", value: "1"},
                {label: "Correctness", value: "2"},
            ],
            mode_details: {
                zoom_type: "",
                lasso_type: "primary"
            },
            mode: "lasso"
        }
    },
    watch: {
        mainViewData: function(mainViewData){
            console.log("mainview data (changed): ", mainViewData);
            const _this = this;
            _this.drawMainView.layout(mainViewData);
            /* calculate relation frequency*/
            // let rels = {}
            // mainViewData.map(d=>{
            //     d["question_concept_correct_answer_relations"].map(r=>{
            //         if(!rels.hasOwnProperty(r[0])){
            //             rels[r[0]] =0
            //         }
            //         rels[r[0]] += 1  
            //     })
            // });
            // console.log("relations: ", rels);
        },
        color_selector_radio(color_mode){
            this.updateMainViewLayout();

            // color_mode select event
            let target_info = {"view": "global_view", "target": "color_mode"}
            let additional_info = {"color_mode": this.color_selector_radio}
            dataService.saveUserDataWrapper("select", target_info, additional_info);
        },
        projection_selector_radio(color_mode){
            this.updateMainViewLayout();

            // projection_mode select event
            let target_info = {"view": "global_view", "target": "projection_mode"}
            let additional_info = {"projection_mode": this.projection_selector_radio}
            dataService.saveUserDataWrapper("select", target_info, additional_info);
        },
        mode(newvalue){
            let local_mode = newvalue;
            let local_mode_details = {
                zoom_type: "",
                lasso_type: ""
            }
            if(local_mode == "zoom"){
                local_mode_details.zoom_type = "primary";
            }else if(local_mode == "lasso"){
                local_mode_details.lasso_type = "primary";
            }
            this.mode_details = local_mode_details;
            
        }
    },
    methods: {
        updateMainViewLayout: function(){
            this.drawMainView.layout(this.mainViewData, this.selected_items, this.selected_relation, 
                this.selected_concepts, this.color_selector_radio, 
                this.projection_selector_radio, this.current_inspected, this.hover_data, this.mode);
        },
        updateColorItems: function(color_items){
            console.log("updateColorItems", color_items);
            this.color_items = color_items;
        },
        onZoomClick(){
            let local_mode = this.mode;
            if(local_mode == "zoom"){
                local_mode = "";
            }else{
                local_mode = "zoom";
            }
            this.mode = local_mode;
            this.updateMainViewLayout();

            // zoom click event
            let target_info = {"view": "global_view", "target": "zoom"}
            dataService.saveUserDataWrapper("click", target_info, {});


        },
        onLassoClick(){
            let local_mode = this.mode;
            if(local_mode == "lasso"){
                local_mode = "";
            }else{
                local_mode = "lasso";
            }
            this.mode = local_mode;
            this.updateMainViewLayout();

            // lasso click event
            let target_info = {"view": "global_view", "target": "lasso"}
            dataService.saveUserDataWrapper("click", target_info, {});
        },
        onResetClick(){
            this.drawMainView.reset_scale();
            this.updateMainViewLayout();

            // reset click event
            let target_info = {"view": "global_view", "target": "reset"}
            dataService.saveUserDataWrapper("click", target_info, {});
        }

        
    },
    mounted: function() {

        //console.log("mounted");
        const _this = this;
        _this.drawMainView = new DrawMainView(_this.containerIdDict, _this.updateColorItems)
        //console.log("inside mainview 1 : ", _this.drawMainView);
        if(!isEmpty(_this.mainViewData)){
            //console.log("inside mainview 2 : ", _this.mainViewData);
            _this.drawMainView.layout(_this.mainViewData);
        }
        pipeService.onSelectConcept(selected_concepts=>{
            if(!isEmpty(_this.mainViewData)){
                this.selected_concepts = selected_concepts;
                this.updateMainViewLayout();
            }
        })
        pipeService.onSelectRelation(selected_relation=>{
            if(!isEmpty(_this.mainViewData)){
                this.selected_relation = selected_relation;
                this.updateMainViewLayout();
            }
        })
        pipeService.onSelectData(selected_items=>{
            if(!isEmpty(_this.mainViewData)){
                this.selected_items = selected_items;
                this.updateMainViewLayout();
            }
        })
        pipeService.onCurrentInspected(currentIndex=>{
            if(!isEmpty(_this.mainViewData)){
                this.current_inspected = currentIndex;
                this.updateMainViewLayout();
            }
        })
        pipeService.onHoverData(hoverIndex=>{
            if(!isEmpty(_this.mainViewData)){
                this.hover_data = hoverIndex;
                this.updateMainViewLayout();
            }
        })
    },

}